import { constant } from '@/constant';
import { ThemeRegistry } from './ThemeRegistry';
import { expansionPageKeys } from './types';

// `modern` is a project theme only and `portdequebec` a page theme only: each takes from its parent, `default`, only
// what it does not register itself, and only for the host it is registered for.
export const themeRegistry = new ThemeRegistry();

themeRegistry.register('default', {
  project: {
    designSystem: 'legacy',
    layout: () => import('./project/default/ProjectLayout.vue'),
    blockRenderers: {
      [constant.Block.Type.Text]: () => import('./project/default/modules/ModuleTextImage.vue'),
      [constant.Block.Type.Video]: () => import('./project/default/modules/ModuleVideo.vue'),
      [constant.Block.Type.Consultation]: () => import('./project/default/modules/ModuleConsultation.vue'),
      [constant.Block.Type.Attachments]: () => import('./project/default/modules/ModuleAttachments.vue'),
      [constant.Block.Type.FrequentlyAskedQuestions]: () => import('./project/default/modules/ModuleFAQ.vue'),
      [constant.Block.Type.Subscription]: () => import('./project/default/modules/ModuleSubscription.vue'),
      [constant.Block.Type.Timeline]: () => import('./project/default/modules/ModuleTimeline.vue'),
      [constant.Block.Type.ContactList]: () => import('./project/default/modules/ModuleContactList.vue'),
      [constant.Block.Type.Hero]: () => import('./project/default/modules/ModuleHero.vue'),
      [constant.Block.Type.Event]: () => import('./project/default/modules/ModuleEvent.vue'),
      [constant.Block.Type.Feedback]: () => import('./project/default/modules/ModuleFeedback.vue'),
      [constant.Block.Type.News]: () => import('./project/default/modules/ModuleNews.vue'),
      [constant.Block.Type.QuestionAnswer]: () => import('./project/default/modules/ModuleQuestionAnswer.vue'),
      [constant.Block.Type.Map]: () => import('./project/default/modules/ModuleMap.vue'),
      [constant.Block.Type.DocumentSubmission]: () => import('./project/default/modules/ModuleDocumentSubmission.vue'),
    },
    expansionPageRenderers: {
      [expansionPageKeys.NewsItem]: () => import('./project/default/expansion-pages/ExpansionNewsItem.vue'),
    },
  },
  page: {
    designSystem: 'legacy',
    layout: () => import('./page/default/PageLayout.vue'),
    blockRenderers: {
      [constant.Block.Type.Hero]: () => import('./page/default/blocks/PageBlockHero.vue'),
      [constant.Block.Type.HomepageHero]: () => import('./page/default/blocks/PageBlockHomepageHero.vue'),
      [constant.Block.Type.FeaturedProjects]: () => import('./page/default/blocks/PageBlockFeaturedProjects.vue'),
      [constant.Block.Type.HomepageItems]: () => import('./page/default/blocks/PageBlockHomepageItems.vue'),
    },
  },
});

themeRegistry.register('modern', {
  parent: 'default',
  project: {
    designSystem: 'modern',
    layout: () => import('./project/modern/ProjectLayout.vue'),
    blockRenderers: {
      [constant.Block.Type.Text]: () => import('./project/modern/modules/ModuleTextImage.vue'),
      [constant.Block.Type.Video]: () => import('./project/modern/modules/ModuleVideo.vue'),
      [constant.Block.Type.Consultation]: () => import('./project/modern/modules/ModuleConsultation.vue'),
      [constant.Block.Type.Attachments]: () => import('./project/modern/modules/ModuleAttachments.vue'),
      [constant.Block.Type.FrequentlyAskedQuestions]: () => import('./project/modern/modules/ModuleFAQ.vue'),
      [constant.Block.Type.Timeline]: () => import('./project/modern/modules/ModuleTimelineVertical.vue'),
      [constant.Block.Type.Subscription]: () => import('./project/modern/modules/ModuleSubscription.vue'),
      [constant.Block.Type.Hero]: () => import('./project/modern/modules/ModuleHero.vue'),
      [constant.Block.Type.ContactList]: () => import('./project/modern/modules/ModuleContactList.vue'),
      [constant.Block.Type.Event]: () => import('./project/modern/modules/ModuleEvent.vue'),
      [constant.Block.Type.Feedback]: () => import('./project/modern/modules/ModuleFeedback.vue'),
      [constant.Block.Type.News]: () => import('./project/modern/modules/ModuleNews.vue'),
      [constant.Block.Type.QuestionAnswer]: () => import('./project/modern/modules/ModuleQuestionAnswer.vue'),
      [constant.Block.Type.Map]: () => import('./project/modern/modules/ModuleMap.vue'),
      [constant.Block.Type.DocumentSubmission]: () => import('./project/modern/modules/ModuleDocumentSubmission.vue'),
    },
    expansionPageRenderers: {
      [expansionPageKeys.NewsItem]: () => import('./project/modern/expansion-pages/ExpansionNewsItem.vue'),
    },
  },
});

themeRegistry.register('portdequebec', {
  parent: 'default',
  page: {
    designSystem: 'modern',
    layout: () => import('./page/portdequebec/PageLayout.vue'),
    blockRenderers: {
      [constant.Block.Type.HomepageHero]: () => import('./page/portdequebec/blocks/PageBlockHomepageHero.vue'),
      [constant.Block.Type.FeaturedProjects]: () => import('./page/portdequebec/blocks/PageBlockFeaturedProjects.vue'),
      [constant.Block.Type.LinksCarousel]: () => import('./page/portdequebec/blocks/PageBlockLinksCarousel.vue'),
    },
  },
});
